import { useAppDispatch, useAppSelector } from "../../../redux/hooks";

import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import {
  deliverySheetsTableHeader,
  getDeliverySheetsTableHeaderTableData,
} from "./tableConfig/deliverySheetsTableConfig";
import { fetchDeliverySheets } from "../../../redux/api/expedition.api";

import DeliverySheetActionButtons from "./components/ActionButtons/DeliverySheetActionButtons";
import { dateForDatabase } from "../../../utils/dateAndTime";
import DeliverySheetsTableHeader from "./components/DeliverySheetsTableHeader";

function DeliverySheets() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      deliverySheets: {
        data: { data: dataDeliverySheets, total: totalDeliverySheets },
        isLoading: isLoadingDeliverySheets,
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  const handleDeliverySheetsActions = (action: TableActions) => {
    dispatch(
      fetchDeliverySheets({
        page: action.tablePagination.page,
        perPage: action.tablePagination.rowsPerPage,
        nod: action.tableSearch?.nodNume,
        ruta: action.tableSearch?.ruta,
        data_crearii: dateForDatabase(action.tableSearch.data_crearii),
      }),
    );
  };

  return (
    <TableWidget
      CustomHeaderComponent={DeliverySheetsTableHeader}
      tableItemsData={getDeliverySheetsTableHeaderTableData(dataDeliverySheets)}
      totalItems={totalDeliverySheets}
      tableLoading={isLoadingDeliverySheets}
      handleTableActions={handleDeliverySheetsActions}
      borderedRow
      tableHeaderData={deliverySheetsTableHeader}
      ActionButtonsComponent={(props: any) => (
        <DeliverySheetActionButtons {...props} />
      )}
    />
  );
}

export default DeliverySheets;
